import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Phone, ChevronDown } from 'lucide-react';
const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isPoliciesOpen, setIsPoliciesOpen] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const togglePolicies = () => {
    setIsPoliciesOpen(!isPoliciesOpen);
  };
  return <header className="bg-[#869CE4] text-white" data-id="element-96">
      <div className="container mx-auto px-4 py-4" data-id="element-97">
        <div className="flex justify-between items-center" data-id="element-98">
          <div className="flex items-center" data-id="element-99">
            <Link to="/" className="text-2xl font-bold" data-id="element-100">
              Peakwave
            </Link>
          </div>
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-6" data-id="element-101">
            <Link to="/" className="hover:text-[#6a7fc7] transition" data-id="element-102">
              Home
            </Link>
            <Link to="/service-coverage" className="hover:text-[#6a7fc7] transition" data-id="element-103">
              Service Coverage
            </Link>
            <Link to="/about" className="hover:text-[#6a7fc7] transition" data-id="element-104">
              About Us
            </Link>
            <Link to="/contact" className="hover:text-[#6a7fc7] transition" data-id="element-105">
              Contact Us
            </Link>
            <Link to="/faq" className="hover:text-[#6a7fc7] transition" data-id="element-106">
              FAQs
            </Link>
            <div className="relative group" data-id="element-107">
              <button className="flex items-center hover:text-[#6a7fc7] transition" onClick={() => setIsPoliciesOpen(!isPoliciesOpen)} data-id="element-108">
                Policies <ChevronDown size={16} className="ml-1" data-id="element-109" />
              </button>
              <div className="absolute left-0 mt-2 w-48 bg-white rounded-md shadow-lg overflow-hidden z-20 hidden group-hover:block" data-id="element-110">
                <Link to="/cancellation-policy" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" data-id="element-111">
                  Cancellation Policy
                </Link>
                <Link to="/refund-policy" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" data-id="element-112">
                  Refund Policy
                </Link>
                <Link to="/privacy-policy" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" data-id="element-113">
                  Privacy & Cookie Policy
                </Link>
                <Link to="/terms-conditions" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" data-id="element-114">
                  Terms & Conditions
                </Link>
              </div>
            </div>
            <div className="bg-[#f05a28] text-white py-2 px-4 rounded-md flex items-center" data-id="element-115">
              <Phone size={16} className="mr-2" data-id="element-116" />
              <a href="tel:08000554969" className="font-semibold" data-id="element-117">
                0800 055 4969
              </a>
            </div>
          </nav>
          {/* Mobile Menu Button */}
          <div className="md:hidden" data-id="element-118">
            <button onClick={toggleMenu} className="text-white" data-id="element-119">
              {isMenuOpen ? <X size={24} data-id="element-120" /> : <Menu size={24} data-id="element-121" />}
            </button>
          </div>
        </div>
        {/* Mobile Navigation */}
        {isMenuOpen && <nav className="md:hidden mt-4 pb-4" data-id="element-122">
            <div className="flex flex-col space-y-3" data-id="element-123">
              <Link to="/" className="hover:text-[#6a7fc7] transition" onClick={toggleMenu} data-id="element-124">
                Home
              </Link>
              <Link to="/service-coverage" className="hover:text-[#6a7fc7] transition" onClick={toggleMenu} data-id="element-125">
                Service Coverage
              </Link>
              <Link to="/about" className="hover:text-[#6a7fc7] transition" onClick={toggleMenu} data-id="element-126">
                About Us
              </Link>
              <Link to="/contact" className="hover:text-[#6a7fc7] transition" onClick={toggleMenu} data-id="element-127">
                Contact Us
              </Link>
              <Link to="/faq" className="hover:text-[#6a7fc7] transition" onClick={toggleMenu} data-id="element-128">
                FAQs
              </Link>
              {/* Policies Dropdown for Mobile */}
              <div data-id="element-129">
                <button className="flex items-center hover:text-[#6a7fc7] transition" onClick={togglePolicies} data-id="element-130">
                  Policies <ChevronDown size={16} className="ml-1" data-id="element-131" />
                </button>
                {isPoliciesOpen && <div className="pl-4 mt-2 space-y-2" data-id="element-132">
                    <Link to="/cancellation-policy" className="block hover:text-[#6a7fc7] transition" onClick={toggleMenu} data-id="element-133">
                      Cancellation Policy
                    </Link>
                    <Link to="/refund-policy" className="block hover:text-[#6a7fc7] transition" onClick={toggleMenu} data-id="element-134">
                      Refund Policy
                    </Link>
                    <Link to="/privacy-policy" className="block hover:text-[#6a7fc7] transition" onClick={toggleMenu} data-id="element-135">
                      Privacy & Cookie Policy
                    </Link>
                    <Link to="/terms-conditions" className="block hover:text-[#6a7fc7] transition" onClick={toggleMenu} data-id="element-136">
                      Terms & Conditions
                    </Link>
                  </div>}
              </div>
              <div className="bg-[#f05a28] text-white py-2 px-4 rounded-md inline-flex items-center w-fit" data-id="element-137">
                <Phone size={16} className="mr-2" data-id="element-138" />
                <a href="tel:08000554969" className="font-semibold" data-id="element-139">
                  0800 055 4969
                </a>
              </div>
            </div>
          </nav>}
      </div>
    </header>;
};
export default Header;